const activeLocks = new Set();

export function lockCutscene(id) {
    if (id == null) return;
    activeLocks.add(id);
}

export function unlockCutscene(id) {
    if (id == null) return;
    activeLocks.delete(id);
}

export function clearCutsceneLocks() {
    activeLocks.clear();
}

export function isCutsceneLocked() {
    return activeLocks.size > 0;
}
